import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { loadStripe } from '@stripe/stripe-js';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Elements } from '@stripe/react-stripe-js';
import { clientSecretSelector, pubKeySelector } from '../../../core/redux/stripe/selectors';
import StripeLoader from './StripeLoader';
import { resetClientSecret } from '../../../core/redux/stripe/actions';

const StripeElements = ({ children, clientSecret, pubKey, resetClientSecretAction }) => {
  if (!pubKey) {
    return <StripeLoader />;
  }

  const stripePromise = useMemo(() => {
    if (pubKey) return loadStripe(pubKey);
    return null;
  }, [pubKey]);

  useEffect(() => {
    return () => {
      if (clientSecret) {
        resetClientSecretAction();
      }
    };
  }, [clientSecret]);

  return (
    <Elements stripe={stripePromise}>
      {children}
      <StripeLoader />
    </Elements>
  );
};

StripeElements.propTypes = {
  children: PropTypes.node.isRequired,
  clientSecret: PropTypes.string,
  pubKey: PropTypes.string,
  resetClientSecretAction: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  clientSecret: clientSecretSelector(state),
  pubKey: pubKeySelector(state),
});

const mapDispatchToProps = dispatch => ({
  resetClientSecretAction: () => dispatch(resetClientSecret()),
});

const enhanced = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhanced(StripeElements);
